const _ = require("lodash");

module.exports = class EmailValidator {
  isValid(email, required) {
    // Regex for testing the email
    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-\_0-9]+\.)+[a-zA-Z]{2,}))$/;

    // Get domain of the email
    const emailDomain = email.substr(email.indexOf('@'));

    // Get list of the blocked emails
    const excludedEmailDomainsPreparation = window.blockedEmailDomains.toString().replace(/\s/g,"");
    const excludedEmailDomains = JSON.parse(excludedEmailDomainsPreparation).split(",");

    // Check if the email is in the blocked domain list
    const excludedDomains = !(excludedEmailDomains.indexOf(emailDomain) > -1);

    // Get list of blocked strings
    const excludedEmailStringsPreparation = window.blockedEmailStrings.toString().replace(/\s/g, "");
    let excludedEmailStrings = JSON.parse(excludedEmailStringsPreparation).split(",");
    excludedEmailStrings = _.filter(excludedEmailStrings, x => !!x)

    // Function to find substring in array
    Array.prototype.findFirstSubstring = function(s) {
      for(let i = 0; i < this.length; i++) {
        if(s.indexOf(this[i]) !== -1) {
          return true;
          // If we need specific location / element key
          // return i;
        }
      }

      // If no occurrences
      return false;
    };

    // Check if the email contains blocked string
    const excludedStrings = !excludedEmailStrings.findFirstSubstring(email);

    // Validate the email
    const validEmail = re.test(String(email).toLowerCase());

    if( !required ) return true;

    // get boolean of whether this is a valid email
    // get boolean of whether this is in the blacklist of email domains
    // get boolean of whether this is in the blacklist of email strings

    return (excludedDomains && validEmail && excludedStrings);
  }
}

if (!("itblFunctions" in window)) {
  window.itblFunctions = {};
}